/**
 * Simple in-memory cache for media presigned URLs.
 * Populated when media is listed or uploaded, used by ImageUploader to display images.
 */

const urlCache = new Map<string, { url: string; expiresAt: number }>();

// URLs are valid for ~1 hour, but we refresh at 45 min to be safe
const TTL_MS = 45 * 60 * 1000;

/**
 * Cache a presigned URL for a media key.
 */
export function cacheMediaUrl(key: string, url: string): void {
  urlCache.set(key, { url, expiresAt: Date.now() + TTL_MS });
}

/**
 * Get a cached presigned URL for a media key.
 * Returns null if not cached or expired.
 */
export function getCachedMediaUrl(key: string): string | null {
  const entry = urlCache.get(key);
  if (!entry) return null;
  if (Date.now() > entry.expiresAt) {
    urlCache.delete(key);
    return null;
  }
  return entry.url;
}

/**
 * Cache multiple media items at once (from list response).
 */
export function cacheMediaUrls(items: Array<{ key: string; url: string }>): void {
  for (const item of items) {
    cacheMediaUrl(item.key, item.url);
  }
}
